import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Autocomplete, FormLabel, RadioGroup, FormControlLabel, Radio, InputLabel, Select, MenuItem, FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormAddSlider = ({ categories, isCategoriesLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [data, setData] = useState({
    title: "",
    description: "",
    button: "",
    link: "",
    page: "home",
    image: null,
  });
  // Handle input changes
  const handleInputChange = (e) => {
    const {name, value, type, files} = e.target;
    if (type === "file") {
      setData((prev) => ({
        ...prev,
        image: files[0],
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChange = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handleRadioChange = (e) => {
    const {name, value} = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Slider.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Sliders");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          type="name"
          autoComplete="off"
          value={data.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          required
          type="text"
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Button"
          name="button"
          required
          type="text"
          autoComplete="off"
          value={data.button}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Link"
          name="link"
          required
          type="text"
          autoComplete="off"
          value={data.link}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
            fullWidth
            margin="normal"
            label="Upload Image"
            name="image"
            type="file"
            InputLabelProps={{shrink: true}}
            onChange={handleInputChange}
            variant="outlined"
            inputProps={{
              accept: "image/*",
            }}
        />
        <FormControl fullWidth size="small">
          <InputLabel>Page</InputLabel>
          <Select
              value={data.page}
              label="page"
              onChange={(e) => handleChange("page", e.target.value)}
          >
            <MenuItem value="home">Home</MenuItem>
            <MenuItem value="OurServices">Our Service</MenuItem>
            <MenuItem value="WhatsappGroups">Whatsapp Groups</MenuItem>
            <MenuItem value="TelegramGroups">Telegram Groups</MenuItem>
            <MenuItem value="SkypeGroups">Teams Groups</MenuItem>
            <MenuItem value="Panels">Panels Groups</MenuItem>
            <MenuItem value="ads">Free Ads</MenuItem>
            <MenuItem value="AddPanel">Add Panel</MenuItem>
            <MenuItem value="Team">Our Team</MenuItem>
            <MenuItem value="AddGroup">Add Group</MenuItem>
            <MenuItem value="post-ad">Post Ad</MenuItem>
            <MenuItem value="smmDomains">Smm Domain</MenuItem>
            <MenuItem value="LastMinute">Last Minute</MenuItem>
          </Select>
        </FormControl>

        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{fontWeight: "bold"}} component="legend">
            Active:
          </FormLabel>
          <RadioGroup
              name="active"
              value={data.active}
              onChange={handleRadioChange}
              row
          >
            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
            <FormControlLabel value="0" control={<Radio/>} label="No"/>
          </RadioGroup>
        </div>
      </div>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
